import React from 'react';

import Avatar from '@mui/material/Avatar';
import { SxProps, Theme, useTheme } from '@mui/material/styles';

// Assuming this wraps MUI's Box correctly
import { AVATAR_SIZES, AvatarSize, FONT_SIZES } from './consts';

const getDefaultStyles = (
  theme: Theme,
  pixelSize: number,
  fontSize: number,
  onClick?: React.MouseEventHandler<HTMLDivElement>,
  inactive?: boolean
): SxProps<Theme> => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: `${pixelSize}px`,
  height: `${pixelSize}px`,
  borderRadius: '64px',
  backgroundColor:
    theme.background?.surfaceDark ?? theme.colors.border.menuButton,
  color: inactive
    ? theme.text?.disabled
    : theme.text?.avatar ?? theme.colors.primary.main,
  fontWeight: 600,
  fontSize: `${fontSize}px`,
  flexShrink: 0,
  cursor: onClick ? 'pointer' : 'default',
});

const LetterAvatar = ({
  name = 'User',
  size = 'xs',
  onClick,
  sx,
  inactive,
  src,
}: {
  name?: string | null | undefined;
  size?: AvatarSize;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  sx?: SxProps<Theme>;
  inactive?: boolean;
  src?: string;
}) => {
  const theme = useTheme();
  const firstLetter = name ? name.charAt(0).toUpperCase() : 'U';
  const pixelSize = AVATAR_SIZES[size];
  const fontSize = FONT_SIZES[size];

  const defaultSx = getDefaultStyles(
    theme,
    pixelSize,
    fontSize,
    onClick,
    inactive
  );

  return (
    <Avatar
      onClick={onClick}
      sx={sx ? [defaultSx, ...(Array.isArray(sx) ? sx : [sx])] : defaultSx}
      aria-label={`Avatar for ${name}`}
      src={src}
    >
      {firstLetter}
    </Avatar>
  );
};

export { LetterAvatar };
